export function validateEmail(value: string): string | null {
  if (!value.trim()) return 'O email é obrigatório';
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) return 'Email inválido';
  return null;
}
